import { render, staticRenderFns } from "./FieldManagerDialog.vue?vue&type=template&id=12fdf375"
import script from "./FieldManagerDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./FieldManagerDialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./FieldManagerDialog.vue?vue&type=style&index=0&id=12fdf375&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports